<template>
  <div class="plans_wrap">
    <div class="topBarBtn">
      <van-button class="newPlanBtn" plain hairline type="info" @click="addPlan"
        >创建计划</van-button
      >
      <van-icon
        name="question-o"
        @click="showTips = true"
        class="icon"
      ></van-icon>
    </div>
    <van-tabs class="tabs" v-model="activeName" @click="handleTabClick">
      <van-tab title="计划列表" name="plan">
        <div class="table-wrap">
          <p-datatable
            :value="plans"
            showGridlines
            stripedRows
            responsiveLayout="scroll"
            :scrollable="true"
            scrollDirection="both"
            class="p-datatable-sm"
          >
            <p-column
              v-for="(column, index) in plan_columns"
              :key="index"
              :field="column.prop"
              :header="column.label"
              :frozen="index === 0"
              :styles="{
                'flex-grow': '1',
                'flex-basis': getColsWidth(column),
                'white-space': 'pre-wrap',
              }"
              :bodyClass="column.prop"
            >
              <template #body="slotProps">
                <span v-if="column.prop === 'switch'">
                  <van-switch
                    v-model="slotProps.data.switch"
                    :active-value="1"
                    :inactive-value="0"
                    @change="switchPlanState(slotProps.data)"
                    size="20px"
                    active-color="#fd9b21"
                    inactive-color="#dcdee0"
                  >
                  </van-switch>
                </span>
                <span v-else-if="column.prop === 'ad_status'">
                  {{ slotProps.data['ad_status'] | adStatusText }}
                </span>
                <span v-else-if="column.prop === 'action'">
                  <a
                    href="javascript:void(0);"
                    type="text"
                    class="actionLink"
                    @click="showDetail(slotProps.data)"
                    >查看计划</a
                  >
                  <a
                    href="javascript:void(0);"
                    type="text"
                    class="actionLink"
                    @click="modifyPlan(slotProps.data)"
                    >修改计划</a
                  >
                  <a
                    href="javascript:void(0);"
                    type="text"
                    class="actionLink"
                    @click="cancelPlan(slotProps.data)"
                    >取消计划</a
                  >
                </span>
                <span v-else>{{ slotProps.data[column.prop] }}</span>
              </template>
            </p-column>
            <template #empty>
              <nodata></nodata>
            </template>
          </p-datatable>
        </div>
        <van-pagination
          v-model="plan_page"
          :total-items="plan_total"
          :items-per-page="plan_page_size"
        />
      </van-tab>
    </van-tabs>
    <van-dialog
      v-model="showTips"
      title="推广计划说明"
      confirmButtonText="我知道了"
    >
      <div class="tipsContent" v-html="tips.replaceAll('\n', '<br/>')" />
    </van-dialog>
  </div>
</template>
<script>
import mixins from '../../../mixins/miniBeanBidding/home.mixin';
import nodata from '../../../components/m/nodata.vue';
export default {
  mixins: [mixins],
  components: {
    'p-datatable': window.datatable,
    'p-column': window.column,
    nodata,
  },
  methods: {
    getColsWidth(item) {
      let width = '90px';
      switch (item.prop) {
        case 'id':
          width = '80px';
          break;
        case 'switch':
          width = '80px';
          break;
        case 'create_time_str':
          width = '160px';
          break;
        case 'promotion_time':
          width = '320px';
          break;
        case 'action':
          width = '240px';
          break;
      }
      return width;
    },
  },
};
</script>
<style lang="scss" scoped>
.table-wrap {
  margin-bottom: 20px;
}
.actionLink {
  margin-right: 20px;
  color: #fd9b21;
}
.topBarBtn {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1001;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  .newPlanBtn {
    border: none;
    font-size: 28px;
    padding-right: 10px;
    line-height: 2;
    &::after {
      content: none;
    }
  }
  ::v-deep .van-icon {
    font-size: 36px;
    color: #fd9b21;
    margin-right: 20px;
  }
}
.tipsContent {
  padding: 10px 30px;
}
</style>
